const de = {
  startPage: {
    selectCountry: 'Land',
    selectCountryDropdown: 'Bitte wählen Sie ein Land',
    statement: 'Um fortzufahren, lesen und akzeptieren Sie bitte die Allgemeinen ',
    // Durch Klicken auf Weiter bestätige ich, dass ich die Allgemeinen
    // Geschäftsbedingungen gelesen und akzeptiert habe
    termsAndConditions: 'Geschäftsbedingungen',
    seeOur: 'Beachten Sie unsere',
    privacyPolicy: 'Datenschutzhinweise',
    privacyPolicyUrl: 'https://www.medel.com/de/privacy-policy/',
    and: 'und unser',
    legalNotice: 'Impressum',
    legalNoticeUrl: 'https://www.medel.com/de/legal-notice',
    readTerms: 'Bitte lesen Sie zuerst die allgemeinen Geschäftsbedingungen',
    continue: 'Fortfahren',
  },
  termsAndConditions: {
    title: 'Geschäftsbedingungen',
    body: 'Das Candidate Selection Tool ist kein Medizinprodukt und dient nicht zur Therapie oder Diagnose. Das Candidate Selection Tool zielt darauf ab, medizinisches Fachpersonal bei der Auswahl von Kandidaten zu unterstützen, indem es Informationen über die Indikationskriterien für die Hörlösungen von MED-EL bereitstellt. Das Candidate Selection Tool bietet nur Informationen zu Hörlösungen von MED-EL. Über potenzielle Risiken und Vorteile für den Kandidaten muss die Aufklärung durch medizinisches Fachpersonal erfolgen. Das Candidate Selection Tool berücksichtigt keine Kostenübernahme durch die Kostenträger für die Produkte. Bitte beachten Sie, dass Angaben und Produkte, die in diesem Candidate Selection Tool verwendet werden, für Länder gelten, die CE-Kennzeichnung akzeptieren*.',
    bodyNote: '* Die australische Version wurde gemäß den lokal geltenden Indikationen adaptiert',
    accept: 'Akzeptieren',
    tooltip: 'Ich habe obenstehendes Statement gelesen und zur Kenntnis genommen, dass MED-EL keine Haftung für die Behandlung, die aufgrund der Ergebnisse dieser Anwendung durchgeführt wird, übernimmt.',
  },
  footer: {
    p1: 'MED-EL Medical Electronics. Alle Rechte vorbehalten',
    p2: 'Sämtliche Informationen dieser Plattform basieren auf offiziellen MED-EL Materialien und können auch auf folgender Website gefunden werden:',
    site: 'www.medel.com',
    cookieSettings: 'Cookie-Einstellungen',
  },
  getInTouch: {
    title: 'Kontaktieren Sie uns',
    p1: 'Sie möchten mehr Informationen über unser Produktportfolio?',
    p2: 'Füllen Sie einfach das Kontaktformular aus und wir antworten in Kürze.',
    buttonLabel: 'Jetzt Kontaktieren',
  },
  common: {
    startAgain: 'Zum Anfang',
    back: 'Zurück',
    confirm: 'Bestätigen',
    contact: 'Kontakt',
    result: 'Resultat',
    discover: 'Mehr erfahren >',
    iAmAware: 'OK',
  },
};

export default de;
